import { render, staticRenderFns } from "./inputFileSmallSingle.vue?vue&type=template&id=0abff342&scoped=true&"
import script from "./inputFileSmallSingle.vue?vue&type=script&lang=js&"
export * from "./inputFileSmallSingle.vue?vue&type=script&lang=js&"
import style0 from "./inputFileSmallSingle.vue?vue&type=style&index=0&id=0abff342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abff342",
  null
  
)

export default component.exports